<template>
    <div class="page page-credit">
        <el-tabs type="border-card">
            <el-tab-pane label="学分管理（个人）">
                <student-credit @to-detail="toDetail"></student-credit>
            </el-tab-pane>
            <el-tab-pane label="学分统计（机构）">
                <organization-credit></organization-credit>
            </el-tab-pane>
        </el-tabs>

        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    import StudentCredit from "./StudentCredit"
    import OrganizationCredit from "./OrganizationCredit"

    export default {
        components: {
            StudentCredit,
            OrganizationCredit
        },
        data() {
            return {

            }
        },
        computed: {},
        created() {

        },
        methods: {
            toDetail(params) {
                this.$router.push({
                    name: 'creditDetail',
                    params: params
                })
            }
        },
    }
</script>

<style scoped lang="scss">
    .page-credit {
        padding-bottom: 0;
        .el-tabs {
            margin-bottom: 15px;
        }
    }
</style>
